import React, {
  FC,
  memo,
  useContext,
  useMemo,
} from 'react';
import { translatedStrings as defaultTranslatedStrings, TranslatedStrings } from './translatedStrings';
import { I18nModel } from './I18nModel';
import { IBingAdsI18nModel } from './types';

export const DEFAULT_LOCALE = 'en-us';

export type I18nProviderProps = {
  translatedStrings?: TranslatedStrings;
  locale?: string;
  children?: React.ReactNode;
  bingAdsI18n?: IBingAdsI18nModel;
  currencyCode?: string;
};

export const I18nContext = React.createContext<I18nModel | null>(null);
export const useI18nContext = () => useContext(I18nContext);

export const I18nProvider: FC<I18nProviderProps> = memo((props) => {
  const {
    bingAdsI18n,
    children,
    currencyCode,
    locale = DEFAULT_LOCALE,
    translatedStrings = defaultTranslatedStrings,
  } = props;

  const i18nModel = useMemo(
    () => new I18nModel(translatedStrings as TranslatedStrings, locale, bingAdsI18n, currencyCode),
    [translatedStrings, locale, bingAdsI18n, currencyCode],
  );

  return (
    <I18nContext.Provider value={i18nModel}>
      {children}
    </I18nContext.Provider>
  );
});

I18nProvider.displayName = 'I18nProvider';
